import 'core-js'
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import AppWrap from './AppWrap';
import registerServiceWorker from './registerServiceWorker';


import { Provider } from 'react-redux'
import rootReducer from './reducers'

import {Router, Route} from 'react-router-dom';
import createBrowserHistory from 'history/createBrowserHistory';
import {listenForHistoryChange} from 'redux-location-state';
import createAppStore from './store';

const history = createBrowserHistory();
const store = createAppStore(rootReducer,history);

listenForHistoryChange(store, history);

ReactDOM.render(
  <Provider {...{store}}>
    <Router {...{history: history}}>
    <Route exact path="/" 
   render={() => <AppWrap/>}/>
    </Router>
    

  </Provider>
  , document.getElementById('root'));
registerServiceWorker();




// WEBPACK FOOTER //
// ./src/index.js